import React from 'react';
import PropTypes from 'prop-types';

const Form = ({ onSubmit, fullWidth, children }) => (
  <form
    onSubmit={onSubmit}
    noValidate
    className={fullWidth ? 'w-full' : undefined}
  >
    {children}
  </form>
);

Form.propTypes = {
  onSubmit: PropTypes.func,
  fullWidth: PropTypes.bool,
  children: PropTypes.any,
};

export default Form;
